// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 5.5rem;
  padding: 0 1.8rem;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

i {
  font-size: 1.8rem;
}

.alert-body {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.orange {
  color: var(--orange);
}

.black {
  color: var(--black);
}

.red {
  color: var(--red);
}

.icon {
  font-size: 1.8rem;
  color: var(--orange);
  width: 24px;
  height: 24px;
}

.text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: 0.005em;
  /* figma */
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  /* or 19px */
  letter-spacing: 0.005em;
}

.text-red {
  color: var(--red);
}

.text-orange {
  color: var(--black);
}

.icon-cancel {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/shared/alert/alert.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;EAEA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;EAGA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;AAFF","sourcesContent":[":host {\n  width: 100%;\n  height: 5.5rem;\n  padding: 0 1.8rem;\n  border-radius: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\ni {\n  font-size: 1.8rem;\n}\n\n.alert-body {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.orange {\n  color: var(--orange);\n}\n\n.black {\n  color: var(--black);\n}\n\n.red {\n  color: var(--red);\n}\n\n.icon {\n  font-size: 1.8rem;\n  color: var(--orange);\n  // color: #D9790C;\n  width: 24px;\n  height: 24px;\n}\n\n.text {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n  letter-spacing: 0.005em;\n  // margin-left: 2rem;\n\n  /* figma */\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 120%;\n  /* or 19px */\n  letter-spacing: 0.005em;\n}\n\n.text-red {\n  color: var(--red);\n}\n\n.text-orange {\n  color: var(--black);\n}\n\n.icon-cancel {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
